<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-card dark
          elevation="5"
          width="100%">
          <v-card-text>
            <v-form ref="biodataFormRef" v-model="valid" @submit.prevent="">
              <v-container fluid>
                <v-layout column align-center class="justify-center align-center">
                  <v-flex>
                    <img
                      v-if="!!this.bioInfo.image"
                      :src="this.bioInfo.image"
                      capture
                      class="profile-edit-pic" />
                      <v-avatar v-else color="purple" size="64" class="mb-3">
                        <v-icon>mdi-account-circle</v-icon>
                      </v-avatar>
                  </v-flex>
                  <v-flex>
                    <input type="file" ref="imageUploader" hidden @change="onFileSelect"/>
                    <v-btn outlined @click="onUploadBtnClick" class="mr-2">Upload Image</v-btn>
                    <!-- <v-btn outlined @click="onTakePictureBtnClick">Take Picture</v-btn> -->
                    <video-dialog v-if="!!isCameraSupported" @img-captured="setCaptureImage" />
                  </v-flex>
                </v-layout>

                <v-layout> 
                  <v-flex>
                    <v-card flat>
                      <v-card-title><h5>General Information</h5></v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                           <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                            <v-text-field
                              autofocus
                              clearable
                              v-model="bioInfo.name"
                              :rules="[requiredRule]"
                              label="Full Name"
                              required>
                            </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="computedDateFormatted"
                                  label="D.O.B"
                                  readonly
                                  hint="DD/MM/YYYY format"
                                  persistent-hint
                                  @blur="date = parseDate(computedDateFormatted)"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="bioInfo.dob"
                                no-title
                                @input="menu1 = false">
                              </v-date-picker>
                            </v-menu>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                clearable
                                v-model="bioInfo.caste"
                                :rules="[requiredRule]"
                                label="Caste"
                                required>
                              </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                clearable
                                v-model="bioInfo.motherName"
                                :rules="[requiredRule]"
                                label="Mother Name"
                                required>
                              </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                clearable
                                v-model="bioInfo.fatherName"
                                :rules="[requiredRule]"
                                label="Father Name"
                                required>
                              </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                clearable
                                v-model="bioInfo.fatherOccupation"
                                :rules="[requiredRule]"
                                label="Father Occupation"
                                required>
                              </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                clearable
                                v-model="bioInfo.motherOccupation"
                                :rules="[requiredRule]"
                                label="Mother Occupation"
                                required>
                              </v-text-field>
                            </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex>
                    <v-card flat>
                      <v-card-title><h5>Education And Professional Info</h5></v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                v-model="bioInfo.qualification"
                                :rules="[requiredRule]"
                                label="Qualification"
                                type="text"
                                required>
                              </v-text-field>
                            </v-flex>
                            
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                v-model="bioInfo.occupation"
                                :rules="[requiredRule]"
                                label="Occupation"
                                type="text"
                                required>
                              </v-text-field>
                            </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex>
                    <v-card flat>
                      <v-card-title><h5>Apperance</h5></v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                            <v-text-field
                              v-model.number="bioInfo.height"
                              :rules="[numRequiredRule]"
                              label="Height"
                              type="number"
                              required>
                            </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                v-model.number="bioInfo.weight"
                                :rules="[numRequiredRule]"
                                label="Weight"

                                type="number"
                                required>
                              </v-text-field>
                            </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex>
                    <v-card flat>
                      <v-card-title><h5>Contact Information</h5></v-card-title>
                      <v-card-text>
                        <v-layout wrap>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                            <v-text-field
                              v-model="bioInfo.email"
                              :rules="[requiredRule]"
                              label="Email"
                              type="email"
                              required>
                            </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                v-model="bioInfo.mobileno"
                                :rules="[requiredRule]"
                                label="Mobile No"
                                type="tel"
                                required>
                              </v-text-field>
                            </v-flex>
                            <v-flex sm12 xs12 md3 lg3 xl4 class="mr-2">
                              <v-text-field
                                v-model="bioInfo.address"
                                :rules="[requiredRule]"
                                label="Address"

                                type="textarea"
                                required>
                              </v-text-field>
                            </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined :disabled="!valid" @click="onSubmitBtnClick">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container> 
</template>

<script>
import getBioData from '../common/bioInfoUtils'
import VideoDialog from '../components/VideoDialog'

export default {
  components: {
    'video-dialog': VideoDialog
  },
  data: () => {
    return {
      isCameraSupported: 'mediaDevices' in navigator, 
      valid: false,
      requiredRule: (value) => (!!(value && value.trim()) || 'required'),
      numRequiredRule: (value) => ((typeof value === 'number' && !isNaN(value)) || 'required'),
      menu1: false,
      bioInfo: {
      image: null,
      name: null,
      dob: null,
      caste: null,
      qualification: null,
      occupation: null,
      motherName: null,
      motherOccupation: null,
      fatherName: null,
      fatherOccupation: null,
      height: null,
      weight: null,
      email: null,
      address: null,
      mobileno: null
      }
    }
  },
  mounted () {
    const bioDataToEdit = getBioData()

    if(bioDataToEdit){
      this.bioInfo =  bioDataToEdit
    }
  },
  computed: {
      computedDateFormatted () {
        return this.formatDate(this.bioInfo.dob)
      },
  },
   methods: {
     getDefaultInfo () {
       return {
        name: 'Mahek Jariwala',
        dob: '1994-08-09',
        caste: 'Leuva Patel',
        qualification: '',
        occupation: '',
        yourOccupation: '',
        motherName: 'Geeta Jariwala',
        motherOccupation: 'House Wife',
        fatherName: 'Harendrabhai',
        fatherOccupation: 'Business',
        height: 5,
        weight: 57,
        email: 'jariwalamahek@gmail.com',
        address: 'chinmay apt',
        mobileno: '9726646791'
       } 
     },
     onUploadBtnClick () {
       const imageUploader = this.$refs.imageUploader
       
       if(imageUploader){
         imageUploader.click()
       }
     },
     setCaptureImage (captureImg) {
      if(captureImg){
        this.$set(this.bioInfo, 'image', captureImg)
      }
     },
     onFileSelect (e) {
       const {target} = e ||{}
       const {files} = target || {}
       const [file] = files || []
       
       if(!file || !file.type || file.type.indexOf('image/') === -1){
         consol.warn('Upload only file image.')
         return
       }

       const reader = new FileReader();
       
       reader.onload = (e) => {
         this.$set(this.bioInfo, 'image', e.target.result)
       }

       reader.readAsDataURL(file)
     },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      onSubmitBtnClick () {
        if(!this.valid || !this.$refs.biodataFormRef.validate()){
          return
        }

        this.storeBioData()
      },
      storeBioData() {
        localStorage.setItem('bioInfo', JSON.stringify(this.bioInfo))
        this.$router.push('/biodata')
      }
    },
};
</script>
